<template>
    <div class="product-item">
        <img :src="item.img" alt="">
        <h3>{{item.title}}</h3>
        <p>{{item.desc}}</p>
    </div>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>
<style>
.product-item{
    flex: 25%;
    text-align: center;
    height: 350px;
    padding: 0 40px;
}
.product-item:first-child,.product-item:nth-child(2),.product-item:nth-child(4), .product-item:nth-child(5){
    border-right: 1px solid #E5E5E5;
}
.product-item:first-child,.product-item:nth-child(2),.product-item:nth-child(3){
    border-bottom: 1px solid #E5E5E5;

}
.product-item img{
    margin-top: 20px;
    width: 50px;
}
.product-item:hover{
    box-shadow: 0 0 15px 0 rgba(0,0,0,0.10); 
    border-radius: 4px;
    background-color: #fff;
    color: #303133;
    transition: .3s;
}
.product-item h3{
    font-family: PingFangSC-Semibold;
    font-size: 22px;
    color: #0083FF;
    letter-spacing: 0;
    text-align: center;
    margin: 20px 0;
}
.product-item p{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
}
</style>